import { API, graphqlOperation } from 'aws-amplify';

const addSurveyMutation = `
  mutation($companyId: String!, $adminId: String!) {
    addSurvey(
      companyId: $companyId,
      adminId: $adminId,
    ) {
      id
    }
  }
`;

const addSurveyQuestionDefaultMutation = `
  mutation($companyId: String!, $surveyId: String!, $body: String!) {
    addSurveyQuestion(
      companyId: $companyId,
      surveyId: $surveyId,
      body: $body
    ) {
      id
    }
  }
`;

const addSurveyQuestionMutation = `
  mutation($companyId: String!, $surveyId: String!, $body: String!, $responseOptions: [String]) {
    addSurveyQuestion(
      companyId: $companyId,
      surveyId: $surveyId,
      body: $body,
      responseOptions: $responseOptions
    ) {
      id
    }
  }
`;

const answerSurveyQuestionMutation = `
  mutation(
    $userId: String!,
    $userAccountType: String!,
    $surveyQuestionId: String!, 
    $surveyId: String!,
    $body: String!
   ) {
    answerSurveyQuestion(
      userId: $userId,
      userAccountType: $userAccountType,
      surveyQuestionId: $surveyQuestionId,
      surveyId: $surveyId,
      body: $body
    ) {
      id
    }
  }
`;

const getActiveSurveyQuery = `
  query($companyId: String!) {
    getActiveSurvey(
      companyId: $companyId
    ) {
      id
      surveyId
      body
      responseOptions
    }
  }
`;

const getSurveyByIdQuery = `
  query($surveyId: String!) {
    getActiveSurvey(
      surveyId: $surveyId
    ) {
      id
      surveyId
      body
      responseOptions
    }
  }
`;

const getSurveyResponsesQuery = `
  query(
    $userId: String,
    $surveyId: String!,
  ) {
    getSurveyResponses(
      userId: $userId,
      surveyId: $surveyId
    ) {
      id
      body
    }
  }
`;

const getYesNoSurveyResultsQuery = `
  query(
    $companyId: String!,
    $surveyId: String
  ) {
    getYesNoSurveyResults(
      companyId: $companyId,
      surveyId: $surveyId
    ) {
      yesPercentage
      yesCount
      noPercentage
      noCount
    }
  }
`;

export function addSurveyQuestionDefault({ COMPANY_ID, SURVEY_ID, BODY }) {
  return API.graphql(
    graphqlOperation(addSurveyQuestionDefaultMutation, {
      companyId: COMPANY_ID,
      surveyId: SURVEY_ID,
      body: BODY,
    })
  );
}

export function addSurveyQuestion({ COMPANY_ID, SURVEY_ID, BODY, OPTIONS }) {
  return API.graphql(
    graphqlOperation(addSurveyQuestionMutation, {
      companyId: COMPANY_ID,
      surveyId: SURVEY_ID,
      body: BODY,
      responseOptions: OPTIONS,
    })
  );
}

export function addSurvey({ COMPANY_ID, ADMIN_ID }) {
  return API.graphql(
    graphqlOperation(addSurveyMutation, {
      companyId: COMPANY_ID,
      adminId: ADMIN_ID,
    })
  );
}

export function answerSurveyQuestion({
  USER_ID,
  USER_ACCOUNT_TYPE,
  SURVEY_QUESTION_ID,
  SURVEY_ID,
  BODY,
}) {
  return API.graphql(
    graphqlOperation(answerSurveyQuestionMutation, {
      userId: USER_ID,
      userAccountType: USER_ACCOUNT_TYPE,
      surveyQuestionId: SURVEY_QUESTION_ID,
      surveyId: SURVEY_ID,
      body: BODY,
    })
  );
}

export function getActiveSurvey({ COMPANY_ID }) {
  return API.graphql(
    graphqlOperation(getActiveSurveyQuery, {
      companyId: COMPANY_ID,
    })
  );
}

export function getSurveyById({ SURVEY_ID }) {
  return API.graphql(
    graphqlOperation(getSurveyByIdQuery, {
      surveyId: SURVEY_ID,
    })
  );
}

export function getSurveyResponses({ USER_ID, SURVEY_ID }) {
  return API.graphql(
    graphqlOperation(getSurveyResponsesQuery, {
      userId: USER_ID,
      surveyId: SURVEY_ID,
    })
  );
}

export function getYesNoSurveyResults({ COMPANY_ID, SURVEY_ID }) {
  return API.graphql(
    graphqlOperation(getYesNoSurveyResultsQuery, {
      companyId: COMPANY_ID,
      surveyId: SURVEY_ID,
    })
  );
}
